import { render, staticRenderFns } from "./JoinPrivateRoom.vue?vue&type=template&id=15af4488"
import script from "./JoinPrivateRoom.vue?vue&type=script&lang=js"
export * from "./JoinPrivateRoom.vue?vue&type=script&lang=js"
import style0 from "./JoinPrivateRoom.vue?vue&type=style&index=0&id=15af4488&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sbsdevops/devops/jenkins-slave/workspace/bizbize-frontend-dev/xpermeet-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15af4488')) {
      api.createRecord('15af4488', component.options)
    } else {
      api.reload('15af4488', component.options)
    }
    module.hot.accept("./JoinPrivateRoom.vue?vue&type=template&id=15af4488", function () {
      api.rerender('15af4488', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Meet/JoinPrivateRoom.vue"
export default component.exports